import { DashboardEventKind } from '../types/events.js';
import { MAX_FEED } from './config.js';
import type { DomRefs } from './dom.js';
import { escapeHtml, fmtHms } from './utils.js';

export interface FeedEntry {
  readonly kind: DashboardEventKind;
  readonly at: string;
  readonly customer: string;
  readonly body: string;
}

export function pushFeed(dom: DomRefs, entry: FeedEntry): void {
  const li = document.createElement('li');
  li.className = 'feed__item';
  li.dataset['kind'] = entry.kind;
  li.innerHTML = `
    <span class="feed__dot"></span>
    <span class="feed__body"><em>${escapeHtml(entry.customer)}</em> · ${escapeHtml(entry.body)}</span>
    <span class="feed__time">${fmtHms(entry.at)}</span>
  `;
  dom.feed.prepend(li);

  const items = dom.feed.querySelectorAll('.feed__item');
  for (let i = MAX_FEED; i < items.length; i++) {
    const old = items[i];
    if (!(old instanceof HTMLElement)) continue;
    old.classList.add('is-fading');
    setTimeout(() => old.remove(), 500);
  }
}

export function clearFeed(dom: DomRefs): void {
  dom.feed.innerHTML = '';
}
